import { Injectable } from '@angular/core';
import { MissingTranslationHandler } from '@ngx-translate/core';
/**
 * I18n missing value
 *
 * @export
 * @class MyMissingTranslationHandler
 * @implements {MissingTranslationHandler}
 */

@Injectable({
  providedIn: 'root',
})
export class MissingTranslationHandlerService
  implements MissingTranslationHandler
{
  handle() {
    return 'some value';
  }
}
